/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import {SubPage, PopupMessage, EmptyState} from '@insticator/insticator-ui'; // iui-material
import NoRequest from 'pages/dashboard/commenting/requestcommentwidget/requeststatus/norequest';
import RequestReceived from 'pages/dashboard/commenting/requestcommentwidget/requeststatus/requestreceived';
//utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/requestcommentwidget/requestcommentwidget_styles';
// dummy data

const hideCommentingConfig = true

/* ========== ~~~~~~~~~~ REQUEST COMMENT WIDGET ~~~~~~~~~~ ========== */
const RequestCommentWidget = (props) => {
    const sendRequestForWidget = () => {
        if(props.mockupGenerator){
            return props.createCommentingUnit(props.accountUUID, props.siteUUID);
        } else if(props.mocked){
           return props.displayModal(true, <PopupMessage
                type={'approve'}
                title={'Are you sure you want to automatically approve commenting for this publisher?'}
                body={<p><br/></p>}
                buttonPrimary={{ text: 'Approve', variant: 'action', action: () => props.approveCommenting(props.accountUUID) && props.displayModal(false)}}
                buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => props.displayModal(false) }}
            />);
        }
        return props.requestCommentWidget(props.accountUUID, props.userEmail);
    };
    const renderCopy = () => !props.status ?
        <NoRequest buttonDisabled={props.status !== null} mockupGenerator={props.mockupGenerator} requestPending={props.requestPending} sendRequest={sendRequestForWidget}/> : <RequestReceived email={props.emailSentTo} />;
    
    const redirectToUsersV2 = () => window.open(`https://publisher-portal.${url.baseURL}/dashboard/commenting/requestaccess`, '_self')

    return(
        <SubPage klass={`requestcommentwidget ${props.classes.requestcommentwidget} disabled-${props.approving}`} name={`requestcommentwidget`}>
            { hideCommentingConfig ?
              <EmptyState 
                graphicName={'error-404'} 
                buttonText={'Go to Commenting Configuration'} 
                bodycopy={<p>Commenting Configuration has been moved to <b>Publisher Portal V2 (Beta)</b></p>} 
                buttonClick={redirectToUsersV2} 
                buttonName={'gotoppv2users'}
              />
              :
              <>
                 {renderCopy()}
                  <div className={'graphic'}>
                      <img src={`${url.image}/illustration-commenting-feature.png`} />
                  </div>
              </>
            }
        </SubPage>
    );
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RequestCommentWidget);
